import { Injectable } from "@nestjs/common";
import { CommonResponseModel, GantCoLinereqModel, GantcoLineRequest, GantColorModel, GantDestinationModel, GantOrderDataModel, GantOrderFilter, GantSizeModel, GantSizeWiseModel, PackMasterColumns, StatusEnum } from "@project-management-system/shared-models";
import axios from "axios";
import * as FormData from 'form-data';
import * as fs from 'fs';
import { PDFDocument } from 'pdf-lib';
import { DataSource, In } from "typeorm";
import * as XLSX from 'xlsx';
import { GenericTransactionManager } from "../../typeorm-transactions";
import { AddressService } from "../Entites@Shahi/address/address-service";
import { AddressRepository } from "../Entites@Shahi/address/address.repo";
import { ColorRepository } from "../Entites@Shahi/color/color-repo";
import { ColorService } from "../Entites@Shahi/color/color-service";
import { SizeRepository } from "../Entites@Shahi/size/size-repo";
import { SizeService } from "../Entites@Shahi/size/size-service";
import { GantItemNoDtos } from "./dto/gant-item-no.dto";
import { GantOrderDetailsDto } from "./dto/gant-orders-details-req";
import { GantCOLineEntity } from "./entities/gant-co-line.entity";
import { GantOrderschildEntity } from "./entities/gant-orders-child.entity";
import { GantOrdersEntity } from "./entities/gant-orders.entity";
import { GantPdfInfoEntity } from "./entities/gant-pdf.entity";
import { PoPackEntity } from "./entities/po-pack.entity";
import { GantCoLineRepository } from "./repositories/gant-co-line.repository";
import { GantOrdersRepository } from "./repositories/gant-orders.repo";
import { GantPdfRepo } from "./repositories/gant-pdf.repo";
import { PoPackRepository } from "./repositories/po-pack.repo";
const { Builder, Browser, By, Select, until } = require('selenium-webdriver');
const moment = require('moment');
const { URL } = require('url')
const ftp = require('basic-ftp');
const util = require('util');
@Injectable()
export class GantService {
  constructor(
    private dataSource: DataSource,
    private gantPdfRepo: GantPdfRepo,
    private gantOrdersRepo: GantOrdersRepository,
    private gantColineRepo: GantCoLineRepository,
    private poPackRepo: PoPackRepository,
    private addressService: AddressService,
    private colorService: ColorService,
    private sizeService: SizeService,
    private addressRepo: AddressRepository,
    private colorRepo: ColorRepository,
    private sizeRepo: SizeRepository,

  ) { }

  async savePackMaster(formData: any): Promise<CommonResponseModel> {
    const transactionManager = new GenericTransactionManager(this.dataSource);
    try {
      await transactionManager.startTransaction();
      const columnArray = [];
      const updatedArray = formData.map((obj) => {
        const updatedObj = {};
        for (const key in obj) {
          const newKey = key.replace(/\s/g, '').replace(/[\(\)\.]/g, '').replace(/-/g, '').replace(/#/g, '');
          if (newKey != '') {
            columnArray.push(newKey);
            updatedObj[newKey] = obj[key];
          }
        }
        return updatedObj;
      });
      const difference = columnArray.filter((element) => !PackMasterColumns.includes(element));
      if (difference.length > 0) {
        await transactionManager.releaseTransaction();
        return new CommonResponseModel(false, 1110, "Excel columns don't match. Please attach the correct file.");
      }
      const filteredArray = updatedArray.filter((obj) => {
        return Object.values(obj).every((value) => value !== null && value !== '' && value !== '-' && value !== ' ');
      });
      const convertedData = filteredArray.map((obj) => {
        const result = {};
        for (const key in obj) {
          result[key] = obj[key] === "" ? null : obj[key];
        }
        return result;
      });
      const repository = transactionManager.getRepository(PoPackEntity);
      for (const data of convertedData) {
        if (!data) continue;
        const existingRecord = await repository.findOne({
          where: {
            packColorCode: String(data.PackColorCode).trim(),
            colorCode: String(data.ColorCode).trim(),
            noOfPack: String(data.NoOfPack).trim(),
            style: String(data.Style).trim()
          },
        });
        if (existingRecord) {
          continue;
        }
        const newRecord = {
          packColorCode: String(data.PackColorCode).trim(),
          colorCode: String(data.ColorCode).trim(),
          noOfPack: String(data.NoOfPack).trim(),
          style: String(data.Style).trim()
        };
        const savedRecord = await repository.save(newRecord);
        if (!savedRecord) {
          console.error("Failed to save record:", data);
          await transactionManager.releaseTransaction();
          return new CommonResponseModel(false, 0, "Failed to save some records");
        }
      }
      await transactionManager.completeTransaction();
      return new CommonResponseModel(true, 1, 'Data saved successfully');
    } catch (err) {
      await transactionManager.releaseTransaction();
      return new CommonResponseModel(false, 0, 'Something went wrong');
    }
  }

  async getPackMasterData(): Promise<CommonResponseModel> {
    try {
      const info = await this.poPackRepo.find()
      if (info) {
        return new CommonResponseModel(true, 1, 'Data retrieved', info)
      } else {
        return new CommonResponseModel(false, 0, 'No data found')
      }
    } catch (err) {
      return new CommonResponseModel(false, 0, 'Something went wrong', err)
    }
  }

  async fileUploadGantPython(files: Express.Multer.File[]): Promise<CommonResponseModel> {
    let extractedData: any;
    try {
      for (const file of files) {
        const formData = new FormData();
        let fileToUpload: Buffer = file.buffer || fs.readFileSync(file.path);
        const fileName = file.originalname;
        if (file.mimetype === 'application/pdf') {
          const pdfDoc = await PDFDocument.load(fileToUpload);
          const newPdf = await PDFDocument.create();
          const [firstPage] = await newPdf.copyPages(pdfDoc, [0])
          newPdf.addPage(firstPage);
          fileToUpload = Buffer.from(await newPdf.save())
        }
        formData.append('file', fileToUpload, { filename: fileName });
        const downloadUrl = 'http://165.22.220.143:2000/upload_invoice';
        const firstResponse = await axios.post(downloadUrl, formData, {
          headers: {
            ...formData.getHeaders(),
          },
          responseType: 'arraybuffer',
        });
        const data = new Uint8Array(firstResponse.data);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonSheet = XLSX.utils.sheet_to_json(sheet, { defval: null, raw: false });
        const extractedExcelData = jsonSheet.filter(row => Object.values(row).some(cell => cell !== null && cell !== ''));
        extractedData = extractedExcelData.flat();
      }

      return new CommonResponseModel(true, 1234, 'Data Extracted', extractedData);
    } catch (error) {
      console.error('Error during file upload and processing:', error);
      throw new Error('Failed to upload and process the files');
    }
  }


  async saveGantOrder(req: any): Promise<CommonResponseModel> {
    const transactionManager = new GenericTransactionManager(this.dataSource);
    try {
      await transactionManager.startTransaction();
      await transactionManager.getRepository(GantOrdersEntity).delete({ poNumber: req.poNumber });
      await transactionManager.getRepository(GantOrderschildEntity).delete({ poNumber: req.poNumber });
      let saved;
      const pdfData = []
      for (const item of req.GantpoItemDetails) {
        for (const variant of item.GantpoItemVariantDetails) {
          const entity = new GantOrdersEntity();
          entity.poNumber = req.poNumber;
          entity.deliveryAddress = req.deliveryAddress;

          entity.style = item.style;
          entity.colorCode = item.colorCode;

          entity.size = variant.size;
          entity.quantity = variant.quantity;
          entity.unitPrice = variant.unitPrice;
          entity.description = variant.description;
          entity.shipMode = variant.shipMode;
          entity.deliveryDate = variant.deliveryDate;
          entity.exFactoryDate = variant.deliveryDate;
          entity.status = StatusEnum.OPEN;
          pdfData.push(entity);
          saved = await transactionManager.getRepository(GantOrdersEntity).save(entity);
          if (!saved) {
            throw new Error('Save failed for GantOrdersEntity');
          }
          const entitys = new GantOrderschildEntity();
          entitys.poNumber = req.poNumber;
          entitys.deliveryAddress = req.deliveryAddress;

          entitys.style = item.style;
          entitys.colorCode = item.colorCode;

          entitys.size = variant.size;
          entitys.quantity = variant.quantity;
          entitys.unitPrice = variant.unitPrice;
          entitys.description = variant.description;
          entitys.shipMode = variant.shipMode;
          entitys.deliveryDate = variant.deliveryDate;
          entitys.exFactoryDate = variant.deliveryDate;
          entitys.status = StatusEnum.OPEN;
          entitys.orderId = entity.id;
          const savedChild = await transactionManager.getRepository(GantOrderschildEntity).save(entitys);
          if (!savedChild) {
            throw new Error('Save failed for GantOrderschildEntity');
          }
        }
      }
      await transactionManager.completeTransaction();
      return new CommonResponseModel(true, 1, 'Data saved successfully', saved);
    } catch (err) {
      await transactionManager.releaseTransaction();
      return new CommonResponseModel(false, 0, 'Failed', err.message || 'Error Occured while Order saving');
    }
  }

  async updatePath(req: any, jsonData: any, poNumber: any): Promise<CommonResponseModel> {
    try {
      let flag = true;
      const entities = []
      for (const res of req) {
        const entity = new GantPdfInfoEntity();
        entity.pdfFileName = res.filename
        entity.filePath = res.path
        entity.poNumber = poNumber
        entity.fileData = jsonData
        entity.fileType = res.mimetype.replace(/text\//g, "")
        entity.createdUser = "admin"
        entity.uploadStatus = "SUCCESS";
        entities.push(entity);
      }
      const uploadDoc = await this.gantPdfRepo.save(entities);
      if (!uploadDoc) {
        flag = false;
      }
      if (flag) {
        return new CommonResponseModel(true, 11, 'uploaded successfully', req);
      }
      else {
        return new CommonResponseModel(false, 11, 'uploaded failed', req);
      }
    }
    catch (error) {
      console.log(error);
    }
  }

  async getPoNumber(req?: any): Promise<CommonResponseModel> {
    try {
      const data = await this.gantOrdersRepo.getPoNumber(req)
      if (data) {
        return new CommonResponseModel(true, 1, 'data retrived Successfully', data)
      } else {
        return new CommonResponseModel(false, 0, 'No Data Found', [])
      }
    } catch (err) {
      throw err
    }
  }

  async getPdfFileInfo(req: any): Promise<CommonResponseModel> {
    try {
      const data = await this.gantPdfRepo.getPdfFileInfo(req)
      if (data) {
        return new CommonResponseModel(true, 1, 'data retrived Successfully', data)
      } else {
        return new CommonResponseModel(false, 0, 'No Data Found', [])
      }
    } catch (err) {
      throw err
    }
  }

  async getStylesData(): Promise<CommonResponseModel> {
    try {
      const data = await this.gantOrdersRepo.getStylesDataRepo()
      if (data) {
        return new CommonResponseModel(true, 1, 'Data retrived Successfully', data)
      } else {
        return new CommonResponseModel(false, 0, 'No Data Found', [])
      }
    } catch (err) {
      throw err
    }
  }

  async getorderDataForInfo(req?: GantOrderFilter): Promise<CommonResponseModel> {
    try {
      const details = await this.gantOrdersRepo.getorderDataForInfo(req);
      if (details.length === 0) {
        return new CommonResponseModel(false, 0, 'No data Found');
      }
      const sizeDateMap = new Map<string, GantOrderDataModel>();
      for (const rec of details) {
        if (!sizeDateMap.has(`${rec.po_number},${rec.style}`)) {
          sizeDateMap.set(
            `${rec.po_number},${rec.style}`,
            new GantOrderDataModel(rec.id, rec.po_number, rec.delivery_address, rec.style, rec.status, rec.ship_mode, rec.delivery_date, [])
          )
        }
        const sizeWiseData = sizeDateMap.get(`${rec.po_number},${rec.style}`).sizeWiseData;
        const existingSizeData = sizeWiseData.find(item => item.colorCode === rec.color_code && item.size === rec.size && item.quantity === rec.quantity && item.unitPrice === rec.unit_price);
        if (!existingSizeData && rec.size !== null) {
          sizeWiseData.push(new GantSizeWiseModel(rec.color_code, rec.size, rec.quantity, rec.unit_price, rec.description));
        }
      }
      const dataModelArray: GantOrderDataModel[] = Array.from(sizeDateMap.values());
      return new CommonResponseModel(true, 1, 'data retrieved', dataModelArray);
    } catch (e) {
      return new CommonResponseModel(false, 0, 'failed', e);
    }
  }

  async excelDownload(values) {
    const res = await this.getorderDataForInfo(values);
    const formattedData = res.data.map((rec) => {
      const description = rec.sizeWiseData?.[0]?.description || '';
      const row = {
        'PO Number': rec.poNumber,
        'Style': rec.style,
        'Color Code': rec.colorCode,
        'Delivery Address': rec.deliveryAddress,
        'Delivery Date': rec.deliveryDate,
        'Ship Mode': rec.shipMode,
        'Description': description,
      };

      rec.sizeWiseData?.forEach((sizeRec) => {
        row[sizeRec.size] = sizeRec.quantity || '-'
      })

      return row;
    });
    const sizeHeaders = new Set();
    res.data.forEach((rec) => {
      rec.sizeWiseData?.forEach((sizeRec) => {
        sizeHeaders.add(sizeRec.size);
      });
    });
    const sortedSizes = Array.from(sizeHeaders).sort();
    const headers = [
      'PO Number', 'Style', 'Color Code', 'Delivery Address', 'Delivery Date', 'Ship Mode', 'Description',
      ...sortedSizes
    ];
    const sheetData = [headers];
    formattedData.forEach((row) => {
      sheetData.push(headers.map((header: any) => row[header] || '-'));
    });
    const ws = XLSX.utils.aoa_to_sheet(sheetData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'SizeWise Data');
    const buffer = XLSX.write(wb, { bookType: 'xlsx', type: 'buffer' });
    return buffer;
  }


  async getorderacceptanceData(req?: GantOrderFilter): Promise<CommonResponseModel> {
    try {
      const details = await this.gantOrdersRepo.getorderacceptanceData(req);
      if (details.length === 0) {
        return new CommonResponseModel(false, 0, 'No data Found');
      }
      const sizeDateMap = new Map<string, GantOrderDataModel>();
      for (const rec of details) {
        if (!sizeDateMap.has(`${rec.po_number},${rec.style}`)) {
          sizeDateMap.set(
            `${rec.po_number},${rec.style}`,
            new GantOrderDataModel(rec.id, rec.po_number, rec.delivery_address, rec.style, rec.status, rec.ship_mode, rec.delivery_date, [])
          );
        }
        const sizeWiseData = sizeDateMap.get(`${rec.po_number},${rec.style}`).sizeWiseData;
        const existingSizeData = sizeWiseData.find(item => item.colorCode === rec.color_code && item.size === rec.size && item.quantity === rec.quantity && item.unitPrice === rec.unit_price);
        if (!existingSizeData && rec.size !== null) {
          sizeWiseData.push(new GantSizeWiseModel(rec.color_code, rec.size, rec.quantity, rec.unit_price, rec.description));
        }
      }
      const dataModelArray: GantOrderDataModel[] = Array.from(sizeDateMap.values());
      return new CommonResponseModel(true, 1, 'data retrieved', dataModelArray);
    } catch (e) {
      return new CommonResponseModel(false, 0, 'failed', e);
    }
  }

  async updateCOLineStatus(req: any): Promise<CommonResponseModel> {
    try {
      if (!req.style) {
        return new CommonResponseModel(false, 0, 'style is undefined');
      }
      await this.gantOrdersRepo.update(
        { poNumber: req.poNumber, style: req.style },
        { status: req.status }
      );
      return new CommonResponseModel(true, 1, 'Success');
    } catch (err) {
      return new CommonResponseModel(false, 0, err)
    }
  }

  async coLineCreationReq(req: any): Promise<CommonResponseModel> {
    const entities: any[] = []
    for (const rec of req.coReqDetails) {
      const entity = new GantCOLineEntity()
      entity.poNumber = rec.poNumber;
      entity.style = rec.style;
      entity.colorCode = rec.colorCode;
      entity.itemNo = rec.itemNo.slice(0, -1) + rec.itemNo.slice(-1).toUpperCase();
      entity.status = 'Open';
      entity.deliveryDate = rec.deliveryDate;
      entity.shipMode = rec.shipMode
      entity.description = rec.description;
      entity.deliveryAddress = rec.deliveryAddress
      entity.createdUser = 'admin';
      entities.push(entity)
    }
    const save = await this.gantColineRepo.save(entities);
    if (save.length) {
      for (const saved of save) {
        await this.updateCOLineStatus({ poNumber: saved.poNumber, style: saved.style, itemNo: saved.itemNo, status: 'Open', })
        const update = await this.gantOrdersRepo.update(
          { poNumber: saved.poNumber, style: saved.style },
          { status: StatusEnum.INPROGRESS }
        );
      }
      return new CommonResponseModel(true, 1, 'CO-Line request created successfully')
    } else {
      return new CommonResponseModel(false, 1, 'CO-Line request failed')
    }
  }

  async getCoPoNumber(req?: any): Promise<CommonResponseModel> {
    const data = await this.gantColineRepo.getCoPoNumber(req)
    if (data.length > 0)
      return new CommonResponseModel(true, 1, 'data retrived', data)
    else
      return new CommonResponseModel(false, 0, 'No data found');
  }

  async getItem(req?: any): Promise<CommonResponseModel> {
    try {
      const data = await this.gantColineRepo.getItem(req)
      if (data) {
        return new CommonResponseModel(true, 1, 'data retrived Successfully', data)
      } else {
        return new CommonResponseModel(false, 0, 'No Data Found', [])
      }
    } catch (err) {
      throw err
    }
  }

  async updateItemNo(req: GantItemNoDtos): Promise<CommonResponseModel> {
    try {
      const update = await this.gantColineRepo.update(
        { id: Number(req.id) },
        { itemNo: req.itemNo, poNumber: req.poNumber, style: req.style }
      );
      if (update) {
        return new CommonResponseModel(true, 1, "ItemNo Update Successfully");
      } else {
        return new CommonResponseModel(false, 0, "Item No: Something went wrong", []);
      }
    } catch (error) {
      return new CommonResponseModel(false, 0, "Error occurred while updating ItemNo", error);
    }
  }

  async deleteCoLine(req: GantItemNoDtos): Promise<CommonResponseModel> {
    try {
      const itemToDelete = await this.gantColineRepo.findOne({ where: { id: Number(req.id) } });

      if (!itemToDelete) {
        return new CommonResponseModel(false, 0, "Item No not found", []);
      }

      if (itemToDelete.status === "Success") {
        itemToDelete.isActive = Boolean(0);
        await this.gantColineRepo.save(itemToDelete);
        return new CommonResponseModel(true, 1, "Deleted Successfully");
      } else {
        const deleteResult = await this.gantColineRepo.delete({ id: Number(req.id) });
        if (deleteResult && deleteResult.affected) {
          return new CommonResponseModel(true, 1, "Deleted Successfully");
        } else {
          return new CommonResponseModel(false, 0, "Something Went Wrong", []);
        }
      }
    } catch (error) {
      return new CommonResponseModel(false, 0, "Error occurred while deleting or updating ItemNo status", error);
    }
  }

  async updateStatusInOrder(req: any): Promise<CommonResponseModel> {
    try {
      const update = await this.gantOrdersRepo.update(
        { poNumber: req.poNumber, style: req.style },
        { status: StatusEnum.OPEN }
      );
      if (update) {
        return new CommonResponseModel(true, 1, "Updated Successfully");
      } else {
        return new CommonResponseModel(false, 0, "Something went wrong", []);
      }
    } catch (error) {
      return new CommonResponseModel(false, 0, "Error occurred while deleting ItemNo", error);
    }
  }


  async deleteCoLines(req: GantItemNoDtos): Promise<CommonResponseModel> {
    try {
      const idsToDelete = Array.isArray(req.id) ? req.id.map(id => Number(id)) : [Number(req.id)];
      const itemsToDelete = await this.gantColineRepo.find({ where: { id: In(idsToDelete) } });
      if (!itemsToDelete || itemsToDelete.length === 0) {
        return new CommonResponseModel(false, 0, "Items not found", []);
      }
      const deletePromises = itemsToDelete.map(async item => {
        if (item.status === "Success") {
          item.isActive = false;
          await this.gantColineRepo.save(item);
        } else {
          const deleteResult = await this.gantColineRepo.delete({ id: item.id });
          if (deleteResult && deleteResult.affected) {
            return new CommonResponseModel(true, 1, "Deleted Successfully");
          } else {
            return new CommonResponseModel(false, 0, "Something Went Wrong", []);
          }
        }
      });
      await Promise.all(deletePromises);
      return new CommonResponseModel(true, itemsToDelete.length, "Deleted Successfully");
    } catch (error) {
      return new CommonResponseModel(false, 0, "Error occurred while deleting or updating ItemNo status", error);
    }
  }

  async getCoLineData(req?: GantOrderFilter): Promise<CommonResponseModel> {
    const data = await this.gantColineRepo.getCoLineData(req)
    if (data.length > 0)
      return new CommonResponseModel(true, 1, 'data retrived', data)
    else
      return new CommonResponseModel(false, 0, 'No data found');
  }

  async getStylesDataCoLine(): Promise<CommonResponseModel> {
    try {
      const data = await this.gantColineRepo.getStylesDataCoLineRepo()
      if (data) {
        return new CommonResponseModel(true, 1, 'Data retrived Successfully', data)
      } else {
        return new CommonResponseModel(false, 0, 'No Data Found', [])
      }
    } catch (err) {
      throw err
    }
  }

  async getOrderdataForCOline(req: GantOrderDetailsDto): Promise<CommonResponseModel> {
    try {
      const ordersData = await this.gantOrdersRepo.find({ where: { poNumber: req.poNumber, style: req.style } });
      const getAddressData = await this.addressService.getAddressInfo()
      const buyerAddressMatchingData = getAddressData.data.map((j => {
        return {
          ...j
        }
      }))
      const foundData = ordersData.map((m) => ({
        colorCode: m.colorCode,
        description: m.description,
        style: m.style
      }));
      /* Find Description According To Its Style And ColorCode */
      const mappedColorCodeAndItsDesc = Array.from(
        new Map(foundData.map(item => [`${item.colorCode}-${item.description}-${item.style}`, item])).values()
      );
      /* Find -PACK At Last Of Description */
      const lastPackItem = mappedColorCodeAndItsDesc.filter(item => /-PACK/.test(item.description)).at(-1);
      /* Find No Of Pack Based On Its Style And ColorCode */
      let colorCodePackMapping = {};
      if (lastPackItem) {
        const colorCodes = mappedColorCodeAndItsDesc.map(item => item.colorCode);
        const packNumbers = await this.poPackRepo.find({
          where: { style: lastPackItem.style }
        });
        const packNumberMap = new Map(
          packNumbers.map(m => [m.packColorCode, m.noOfPack])
        );
        colorCodes.forEach(colorCode => {
          colorCodePackMapping[colorCode] = packNumberMap.get(colorCode) || 1;
        });
      }
      // const colorsDatas = [...new Set(ordersData.map((m) => m.colorCode))];
      // const noOfPackMap = new Map<string, number>();
      // colorsDatas.forEach(colorCode => {
      //   const packEntry = packNumbers.find(p => p.colorCode === colorCode);
      //   noOfPackMap.set(colorCode, packEntry ? parseInt(packEntry.noOfPack) : 1);
      // });
      const destinationColSizesMap = new Map<string, Map<string, Map<string, { size: string, quantity: string, price: string }[]>>>();
      const poMap = new Map<string, GantOrdersEntity>();
      for (const order of ordersData) {
        let dest;
        poMap.set(`${order.poNumber}`, order)
        const orginalOrderDeliveryAddress = order.deliveryAddress.trim();
        const matchingData = buyerAddressMatchingData.find(j => j.deliveryAddress === orginalOrderDeliveryAddress);
        if (matchingData) {
          dest = orginalOrderDeliveryAddress
        }
        if (!destinationColSizesMap.has(`${order.poNumber}`)) {
          destinationColSizesMap.set(`${order.poNumber}`, new Map<string, Map<string, { size: string, quantity: string, price: string }[]>>());
        }
        if (!destinationColSizesMap.get(`${order.poNumber}`).has(dest)) {
          destinationColSizesMap.get(`${order.poNumber}`).set(dest, new Map<string, { size: string, quantity: string, price: string }[]>());
        }
        const check = await this.colorRepo.find({ where: { item: req.itemNo, style: order.style, colorCode: order.colorCode } });
        const color = check.length > 0 ? check.map(i => i.movexColorName.toUpperCase()).join(',') : order.colorCode.toUpperCase();
        if (!destinationColSizesMap.get(order.poNumber).get(dest).has(color)) {
          destinationColSizesMap.get(order.poNumber).get(dest).set(color, [])
        }

        const sizecheck = await this.sizeRepo.find({ where: { size: order.size } })
        const sizecheckData = sizecheck.length > 0 ? sizecheck.map(item => item.movexSize.toUpperCase()).join(',') : order.size.toUpperCase();
        const sizesMap = destinationColSizesMap.get(order.poNumber).get(dest).get(color);

        /* Quantity Multiply Logic According to its Color Code */
        let orginalColorCode
        if (!/^\d{3}/.test(color)) {
          const findMovexColor = await this.colorRepo.find({ where: { movexColorName: color } });
          if (findMovexColor) {
            orginalColorCode = findMovexColor.map(m => m.colorCode);
          }
        }
        if (orginalColorCode === undefined) {
          orginalColorCode = color
        }
        const noOfPack = colorCodePackMapping[orginalColorCode] ? String(colorCodePackMapping[orginalColorCode]) : '1';
        if (sizecheckData) {
          const existingSize = sizesMap.find(sizeObj => sizeObj.size === sizecheckData);
          if (existingSize) {
            existingSize.quantity = (parseFloat(existingSize.quantity.replace(/,/g, '')) + parseFloat(order.quantity.replace(/,/g, '')) * parseFloat(noOfPack)).toFixed(3);
          } else {
            sizesMap.push({ size: sizecheckData, quantity: (parseFloat(order.quantity.replace(/,/g, '')) * parseFloat(noOfPack)).toFixed(3), price: order.unitPrice });
          }
        }
      }
      const coData = [];
      destinationColSizesMap.forEach((destColorSize, poNumber) => {
        const desArray = [];
        destColorSize.forEach((colorSizes, dest) => {
          const ColArray = [];
          colorSizes.forEach((sizes, color) => {
            const sizeArray = sizes.map(size => new GantSizeModel(size.size, size.quantity, size.price));
            const col = new GantColorModel(color, sizeArray, sizeArray[0].price)
            ColArray.push(col);
          });
          const matchingData = buyerAddressMatchingData.find(j => j.deliveryAddress === dest);
          const des = new GantDestinationModel(
            dest,
            ColArray,
            matchingData?.buyerAddressCode,
            matchingData?.deliveryAddressCode,
          );
          desArray.push(des);
        });

        const poInfo = poMap.get(poNumber);
        const co = new GantCoLinereqModel(poInfo.poNumber, poInfo.unitPrice, poInfo.deliveryDate, poInfo.exFactoryDate, poInfo.style, desArray);
        coData.push(co);
      });
      if (coData.length > 0) {
        return new CommonResponseModel(true, 1, 'Data Retrieved Successfully', coData);
      } else {
        return new CommonResponseModel(false, 0, 'No data found');
      }
    } catch (err) {
      console.error(err);
      throw new Error('Error retrieving data');
    }
  }


  async createCOline(): Promise<CommonResponseModel> {
    const po = await this.gantColineRepo.getDataforCOLineCreation();
    if (!po) {
      return new CommonResponseModel(false, 0, 'No CO-Line creation requests')
    }
    let driver = await new Builder().forBrowser(Browser.CHROME).build();
    try {
      await driver.get('http://intranetn.shahi.co.in:8080/ShahiExportIntranet/subApp?slNo=2447#');
      await driver.findElement(By.id('username')).sendKeys('99901347');
      await driver.findElement(By.id('password')).sendKeys('99901347');
      await driver.findElement(By.css('button.btn-primary')).click();
      await driver.get('http://intranetn.shahi.co.in:8080/ShahiExportIntranet/subApp?slNo=2447')
      const newPAge = await driver.executeScript(
        `javascript:openAccessPage('http://intranet.shahi.co.in:8080/IntraNet/CRMPRDNEW.jsp', 'CRM', '2448', 'R', '99901347', 'N', '20634576', 'null');`
      );
      const windowHandles = await driver.getAllWindowHandles()
      await driver.switchTo().window(windowHandles[1]);
      const frame = await driver.findElement(By.id('mainFrame'));
      await driver.switchTo().frame(frame)
      const coLine = new GantcoLineRequest();
      let buyerValue1;
      let buyerValue2;
      // let agent;
      let buyerAddress;
      let deliveryAddress;
      // let pkgTerms;
      // let paymentTerms;
      let styleNo;
      const update = await this.gantColineRepo.update({ poNumber: po.po_number, style: po.style, itemNo: po.item_no }, { status: 'Inprogress' });
      const response = await this.getOrderdataForCOline({ poNumber: po.po_number, style: po.style, itemNo: po.item_no })
      const coData = response.data[0];
      coLine.poNumber = coData.poNumber
      const date = new Date(po.delivery_date);
      const formattedDate = `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
      coLine.deliveryDate = formattedDate;
      coLine.salesPrice = coData.salesPrice
      coLine.currency = coData.currency
      coLine.destinations = coData.destinations
      coLine.exFactoryDate = formattedDate
      const request = coData.destinations[0]?.name;
      console.log("----------------start----------------")
      if (!request) {
        const update = await this.gantColineRepo.update(
          { poNumber: po.po_number, style: po.style },
          { status: "Failed", errorMsg: `Address Mismatched - ${po.delivery_address}`, isActive: false }
        );
        if (update.affected) {
          await this.updateCOLineStatus({ poNumber: po.po_number, style: po.style, status: StatusEnum.FAILED });
          return new CommonResponseModel(false, 0, "Address Mismatched")
        }
      }
      console.log("----------------end----------------")
      styleNo = coData.style
      buyerAddress = coData.destinations[0]?.buyerAddressCode
      deliveryAddress = coData.destinations[0]?.deliveryAddressCode
      if (buyerAddress === undefined || buyerAddress === null || buyerAddress === "" ||
        deliveryAddress === undefined || deliveryAddress === null || deliveryAddress === ""
      ) {
        const update = await this.gantColineRepo.update(
          { poNumber: po.po_number, style: po.style },
          { status: "Failed", errorMsg: `Address Mismatched - ${po.delivery_address}`, isActive: false }
        );
        if (update.affected) {
          await this.updateCOLineStatus({ poNumber: po.po_number, style: po.style, status: StatusEnum.FAILED });
          return new CommonResponseModel(false, 0, "Address Mismatched")
        }
      }
      buyerValue1 = "GAB-GANT AB"
      buyerValue2 = "GAN00002-GANT AB"
      // agent = "NA-DIRECT CUSTOMER"
      // pkgTerms = "BOX-BOXES"
      // paymentTerms = "081-TT  90 Days"
      await driver.sleep(3000)
      const apps = await driver.wait(until.elementLocated(By.xpath('//*[@id="mainContainer"]/div[1]')));
      const allApps = await apps.findElements(By.tagName('span'));
      for (const app of allApps) {
        if ((await app.getAttribute('innerText')).includes('Style Orders')) {
          await driver.executeScript('arguments[0].click();', app);
          break;
        }
      }
      await driver.sleep(5000)
      await driver.wait(until.elementLocated(By.id('styleid2H')))
      await driver.findElement(By.id('styleid2H')).sendKeys(po.item_no);
      await driver.sleep(3000)
      await driver.wait(until.elementLocated(By.id('bgpset1')));
      const dropdownElement1 = await driver.findElement(By.id('bgpset1'));
      const dropdown1 = await driver.wait(until.elementIsVisible(dropdownElement1)).then(element => new Select(element))
      await dropdown1.selectByValue(buyerValue1)
      await driver.sleep(3000)
      await driver.wait(until.elementLocated(By.id('byr')));
      const dropdownElement2 = await driver.findElement(By.id('byr'));
      const dropdown2 = await driver.wait(until.elementIsVisible(dropdownElement2)).then(element => new Select(element))
      await dropdown2.selectByValue(buyerValue2)
      await driver.sleep(1000)
      await driver.wait(until.elementLocated(By.id('CreateOrderID')))
      await driver.sleep(3000)
      await driver.findElement(By.id('CreateOrderID')).click();

      try {
        let getTextFromCreatedIdClicked = await driver.wait(until.elementLocated(By.xpath("//tr/td/ul/li/span")), 5000)
        if (getTextFromCreatedIdClicked) {
          let spanText = await getTextFromCreatedIdClicked.getText();
          console.log(spanText, "span text");
          if (spanText) {
            const update = await this.gantColineRepo.update({ poNumber: po.po_number, style: po.style }, { status: "Failed", errorMsg: `${spanText}`, isActive: false })
            if (update.affected) {
              await this.updateCOLineStatus({ poNumber: po.po_number, style: po.style, status: StatusEnum.FAILED });
              return new CommonResponseModel(false, 0, "Span Error");
            }
          }
        }
      }
      catch (error) {
        console.log("Text Not Found");
      }
      console.log("Proceeding to the next steps")
      await driver.wait(until.elementLocated(By.id('bpo')))
      await driver.findElement(By.id('bpo')).clear();
      await driver.findElement(By.id('bpo')).sendKeys(coLine.poNumber);

      await driver.wait(until.elementLocated(By.id('bus')))
      await driver.findElement(By.id('bus')).clear();
      await driver.findElement(By.id('bus')).sendKeys(styleNo);

      // await driver.wait(until.elementLocated(By.id('agnt')));
      // const agentDropDown = await driver.findElement(By.id('agnt'));
      // await driver.executeScript(`arguments[0].value = '${agent}';`, agentDropDown)

      await driver.wait(until.elementLocated(By.name('dojo.EXFACTORYDATE')));
      await driver.findElement(By.name('dojo.EXFACTORYDATE')).clear();
      await driver.findElement(By.name('dojo.EXFACTORYDATE')).sendKeys(coLine.exFactoryDate)

      await driver.wait(until.elementLocated(By.name('dojo.delydt')));
      await driver.findElement(By.name('dojo.delydt')).clear();
      await driver.findElement(By.name('dojo.delydt')).sendKeys(coLine.deliveryDate)

      await driver.wait(until.elementLocated(By.name('byd')));
      const dropdown = await driver.findElement(By.name('byd'));
      const options = await dropdown.findElements(By.tagName('option'));

      const optionValues = [];
      for (const option of options) {
        const value = await option.getAttribute('value');
        optionValues.push(value);
      }
      const number = optionValues.find(value => {
        return Number(value.split('-')[0].trim()) == Number(buyerAddress)
      });
      await driver.executeScript(`arguments[0].value = '${number}';`, dropdown)
      // await driver.wait(until.elementLocated(By.xpath('//*[@id="cur"]')));
      // const curDropdown = await driver.findElement(By.xpath('//*[@id="cur"]'));
      // const cur = "USD";
      // await driver.executeScript(`arguments[0].value = '${cur}';`, curDropdown);

      await driver.wait(until.elementLocated(By.xpath('//*[@id="price"]')));
      await driver.findElement(By.xpath('//*[@id="price"]')).clear();
      await driver.findElement(By.xpath('//*[@id="price"]')).sendKeys(coLine.salesPrice)

      // await driver.wait(until.elementLocated(By.id('packtrm')));
      // const pkgTermsDropDown = await driver.findElement(By.id('packtrm'));
      // await driver.executeScript(`arguments[0].value = '${pkgTerms}';`, pkgTermsDropDown)

      // await driver.wait(until.elementLocated(By.id('ptr')));
      // const ptrDropDown = await driver.findElement(By.id('ptr'));
      // await driver.executeScript(`arguments[0].value = '${paymentTerms}';`, ptrDropDown)
      await driver.sleep(10000)
      for (let dest of coLine.destinations) {
        const colorsContainer = await driver.wait(until.elementLocated(By.xpath('//*[@id="COContainer"]')));
        const colorsTabs = await colorsContainer.findElements(By.tagName('span'));
        for (const tab of colorsTabs) {

          if ((await tab.getAttribute('innerText')) == dest.name) {
            await driver.executeScript('arguments[0].click();', tab);
            for (let [colorIndex, color] of dest.colors.entries()) {
              for (let [sizeIndex, size] of color.sizes.entries()) {
                if (colorIndex === 0) {
                  await driver.wait(until.elementLocated(By.xpath("//tbody/tr[2]/td/div")))
                  let labelElements: any[] = await driver.findElements(By.xpath("//tbody/tr[2]/td/div"));
                  const fileteredElements: any[] = [];
                  for (const labelElement of labelElements) {
                    const ele = (await labelElement.getText())?.trim();
                    ele.length > 0 ? fileteredElements.push(labelElement) : '';
                  }
                  let tabIndex = 1;
                  const inputElementsXPath = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div[${tabIndex}]/div/table/tbody/tr/td[2]/table/tbody/tr[1]/td/div/table/tbody/tr[1]/td/div/input[@name='salespsizes']`;
                  const string = `${po.item_no}ZD${tabIndex.toString().padStart(3, '0')}`
                  await driver.wait(until.elementLocated(By.id(`bydline/${string}`)));
                  const dropdown = await driver.findElement(By.id(`bydline/${string}`));
                  const options = await dropdown.findElements(By.tagName('option'));
                  const optionValues = [];
                  for (const option of options) {
                    const value = await option.getAttribute('value');
                    optionValues.push(value);
                  }
                  const number = optionValues.find(value => value.includes(deliveryAddress)); // give the dynamic value here
                  await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
                  // Find all the input fields in the first row.
                  const inputElements = await driver.findElements(By.xpath(inputElementsXPath));
                  // Create a map of size labels to input fields.
                  const sizeToInputMap = {};
                  for (let i = 0; i < fileteredElements.length; i++) {
                    const label = (await fileteredElements[i].getText()).trim().toUpperCase().toString(); // Remove leading/trailing spaces
                    if (label.length)
                      sizeToInputMap[label] = inputElements[i];
                  }
                  const inputField = await sizeToInputMap[size.name.trim().toUpperCase().toString()];
                  if (inputField) {
                    // Clear the existing value (if any) and fill it with the new price.
                    // await inputField.clear();
                    // await inputField.sendKeys(size.price);
                  }
                }
                const inputId = `${size.name}:${color.name.toString().toUpperCase().trim()}:${dest.name}`.replace(/\*/g, '');
                const input = await driver.wait(until.elementLocated(By.id(inputId)))
                await driver.findElement(By.id(inputId)).sendKeys(`${size.qty}`);
              }
            }
          }
          else if ((await tab.getAttribute('innerText')) == 'ASSORTED') {
            await driver.executeScript('arguments[0].click();', tab);
            const sizesDivElementId = `nameDiv1${po.item_no}ZD001`;
            const colorsDivElementId = `nameDiv3${po.item_no}ZD001`;
            const allSizes = [];
            console.log('---------------------------------------------------------------');
            await driver.wait(until.elementLocated(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`)));
            // -----------------------   SIZES Reading from UI logic start ---------------
            // read all the sizes from the DOM
            let labelElements: any[] = await driver.findElements(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`));
            const totalElements = labelElements?.length;
            console.log('Total elements : ' + totalElements);
            labelElements.forEach(async r => {
              const label = (await r.getText()).trim().toUpperCase().toString();
              allSizes.push(label);
            });
            // Now iterate a random iteration of 10 loops to cover all sizes in the UI by doing a horizontal scroll
            let i = 1;
            while (i <= 10) {
              // Try to jump to right hand side of the div by 8 units. (Dont try more than that. Test and change this value if needed)
              const toJump = Math.min(i * 8, totalElements);
              const rightEle = driver.findElement(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td[${toJump}]`));
              // scroll the pointer to right side
              driver.executeScript("arguments[0].scrollIntoView()", rightEle);
              driver.sleep(1000);
              // read all the visible sizes from the DOM
              let currentUserVisbileElements: any[] = await driver.findElements(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`));
              // At some nth iteration, we can set all the sizes to the array once it is visible on the scope of selenium reader
              // console.log("Iteration " + i + " : " + toJump + " --- " + currentUserVisbileElements.length);
              currentUserVisbileElements.forEach(async (r, index) => {
                if (allSizes[index] == '') {
                  // console.log(index, "index");
                  const label = (await r.getText()).trim().toUpperCase().toString();
                  allSizes[index] = label;
                }
              });
              console.log(allSizes, "allSizessssssss");
              i++;
            }
            // construct a reverse mapping of size => column location for easy scrolling during qty input
            const sizeToDisplayRowColumnIndex = [];
            allSizes.forEach((size, i) => {
              sizeToDisplayRowColumnIndex[size] = i;
            })
            // -----------------------   SIZES Reading from UI logic END ---------------
            // ---------------------- COLOR GETTING LOGIC START -------------------------
            const colorsInTable = [];
            const colorsToDisplayRowColumnIndex = [];
            // get the total colors for the current PO from the UI
            const totalColorElements: any[] = await driver.findElements(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr`));
            let cc = 0;
            for (const r of totalColorElements) {
              const bottomEle = await driver.findElement(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${cc + 1}]`));
              await driver.executeScript("arguments[0].scrollIntoView()", bottomEle);
              await driver.sleep(500);
              const sepcificRowColorEle = await driver.findElements(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${cc + 1}]/td`));
              const displayingColor = (await sepcificRowColorEle[0]?.getText());
              colorsInTable.push(displayingColor);
              cc++;
            }
            // now reverse map the color -> exact row index in the DOM
            colorsInTable.forEach((color, index) => {
              colorsToDisplayRowColumnIndex[color] = index;
            });
            // ---------------------- COLOR GETTING LOGIC END -------------------------
            for (let [colorIndex, color] of dest.colors.entries()) {
              let matchedColor = null;
              let failedColor = null;
              const multiColors = color.name.split(',').map(name => name.trim());
              for (const originalColorName of multiColors) {
                if (/^\d{3}$/.test(originalColorName)) {
                  matchedColor = colorsInTable.find(colorEntry =>
                    colorEntry.slice(-3) === originalColorName
                  );
                  if (matchedColor) break;
                } else {
                  if (colorsInTable.includes(originalColorName)) {
                    matchedColor = originalColorName;
                    break;
                  }
                }
              }
              if (!matchedColor) {
                failedColor = multiColors.join(', ');
                await this.gantColineRepo.update(
                  { poNumber: po.po_number, style: po.style },
                  { status: 'Failed', errorMsg: `Color Mismatched ${failedColor}`, isActive: false }
                );
                await this.updateCOLineStatus({ poNumber: po.po_number, style: po.style, status: StatusEnum.FAILED });
                return new CommonResponseModel(false, 0, 'Color Mismatched');
              }

              const exactColorRowScrollLocation = colorsToDisplayRowColumnIndex[matchedColor] + 1;
              if (colorsToDisplayRowColumnIndex[matchedColor] == undefined) {
                await this.gantColineRepo.update(
                  { poNumber: po.po_number, style: po.style },
                  { status: 'Failed', errorMsg: `Color Mismatched ${failedColor}`, isActive: false }
                );
                await this.updateCOLineStatus({ poNumber: po.po_number, style: po.style, status: StatusEnum.FAILED });
                return new CommonResponseModel(false, 0, 'Color Mismatched');
              }
              const bottomEle = await driver.findElement(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${exactColorRowScrollLocation}]`));
              driver.executeScript("arguments[0].scrollIntoView()", bottomEle);
              driver.sleep(500);
              console.log(matchedColor, "Matched Color");
              try {
                const saleInput = `${matchedColor.toUpperCase().trim()}ASSORTED`;
                console.log(saleInput, "Sale Input");
                const salePriceInput = await driver.findElement(By.id(saleInput), 10000);
                await salePriceInput.sendKeys(`${color.sizes[0].price}`);
              } catch (error) {
                console.error("Error finding sale price input:", error);
                await this.gantColineRepo.update(
                  { poNumber: po.po_number, style: po.style },
                  { status: 'Failed', errorMsg: `Color Mismatched ${failedColor}`, isActive: false }
                );
                await this.updateCOLineStatus({ poNumber: po.po_number, style: po.style, status: StatusEnum.FAILED });
                return new CommonResponseModel(false, 0, 'Color Mismatched');
              }
              for (let [sizeIndex, size] of color.sizes.entries()) {
                let matchedSize = null;
                let failedSize = null;
                failedSize = size.name;
                const sizeNameVariants = size.name.trim().toUpperCase().split(',').map(val => val.trim());
                console.log(sizeNameVariants, "sizeNameVariants")
                for (const sizeVariant of sizeNameVariants) {
                  if (allSizes.includes(sizeVariant)) {
                    matchedSize = sizeVariant;
                  }
                }

                if (matchedSize) {
                  console.log(matchedSize, "iopiopiop")
                  const exactSizeColumnScrollLocation = sizeToDisplayRowColumnIndex[matchedSize] + 1;
                  if (!exactSizeColumnScrollLocation) {
                    const update = await this.gantColineRepo.update(
                      { poNumber: po.po_number, style: po.style },
                      { status: 'Failed', errorMsg: `Size Mismatched ${failedSize}`, isActive: false }
                    );
                    await this.updateCOLineStatus({
                      poNumber: po.po_number,
                      style: po.style,
                      status: StatusEnum.FAILED,
                    });
                    return new CommonResponseModel(false, 0, 'Size Mismatched')
                  }
                  const rightEle = await driver.findElement(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td[${exactSizeColumnScrollLocation}]`));
                  driver.executeScript("arguments[0].scrollIntoView()", rightEle);
                  driver.sleep(300);
                  await driver.wait(until.elementLocated(By.xpath("//tbody/tr[2]/td/div")))
                  let labelElements: any[] = await driver.findElements(By.xpath("//tbody/tr[2]/td/div"));
                  const fileteredElements: any[] = [];
                  for (const labelElement of labelElements) {
                    const ele = (await labelElement.getText())?.trim();
                    ele.length > 0 ? fileteredElements.push(labelElement) : '';
                  }
                  let tabIndex = 1;
                  const inputElementsXPath = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div[${tabIndex}]/div/table/tbody/tr/td[2]/table/tbody/tr[1]/td/div/table/tbody/tr[1]/td/div/input[@name='salespsizes']`;
                  const string = `${po.item_no}ZD${tabIndex.toString().padStart(3, '0')}`
                  await driver.wait(until.elementLocated(By.id(`bydline/${string}`)));
                  const dropdown = await driver.findElement(By.id(`bydline/${string}`));
                  const options = await dropdown.findElements(By.tagName('option'));
                  const optionValues = [];
                  for (const option of options) {
                    const value = await option.getAttribute('value');
                    optionValues.push(value);
                  }
                  const number = optionValues.find(value => {
                    return Number(value.split('-')[0].trim()) == Number(deliveryAddress)
                  });
                  // console.log(number, "nummmm")
                  await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
                  const inputElements = await driver.findElements(By.xpath(inputElementsXPath));
                  const sizeToInputMap = {};
                  for (let i = 0; i < fileteredElements.length; i++) {
                    const label = (await fileteredElements[i].getText()).trim().toUpperCase().toString();
                    if (label.length)
                      sizeToInputMap[label] = inputElements[i];
                  }
                  // const labelNames = Object.keys(sizeToInputMap);
                  const inputField = sizeToInputMap[matchedSize.trim().toUpperCase().toString()];
                  if (inputField) {
                    await inputField.clear();
                    await inputField.sendKeys(size.price);
                  } else {
                    await this.gantColineRepo.update(
                      { poNumber: po.po_number, style: po.style },
                      { status: 'Failed', errorMsg: `Size Mismatched ${failedSize}`, isActive: false }
                    );
                    await this.updateCOLineStatus({
                      poNumber: po.po_number,
                      style: po.style,
                      status: StatusEnum.FAILED,
                    });
                    return new CommonResponseModel(false, 0, 'Size Mismatched');
                  }
                } else {
                  await this.gantColineRepo.update(
                    { poNumber: po.po_number, style: po.style },
                    { status: 'Failed', errorMsg: `Size Mismatched ${failedSize}`, isActive: false }
                  );
                  await this.updateCOLineStatus({
                    poNumber: po.po_number,
                    style: po.style,
                    status: StatusEnum.FAILED,
                  });
                  return new CommonResponseModel(false, 0, 'Size Mismatched');
                }
                const inputId = `${matchedSize}:${matchedColor.toUpperCase().toString().trim()}:ASSORTED`.replace(/\*/g, '');
                console.log(inputId, "ppppp")
                const input = await driver.wait(until.elementLocated(By.id(inputId)), 10000)
                await driver.findElement(By.id(inputId)).sendKeys(`${size.qty}`);
              }
            }
          }
        }
      }
      await driver.sleep(10000)
      const element = await driver.findElement(By.id('OrderCreateID')).click();
      await driver.wait(until.alertIsPresent(), 10000);
      const alert = await driver.switchTo().alert();
      await alert.accept();
      if (await this.isAlertPresent(driver)) {
        const alert = await driver.switchTo().alert();
        const alertText = await alert.getText();
        const update = await this.gantColineRepo.update(
          { poNumber: po.po_number, style: po.style },
          { status: StatusEnum.FAILED, errorMsg: alertText, isActive: false }
        );
        await driver.sleep(3000)
        await this.updateCOLineStatus({ poNumber: po.po_number, style: po.style, status: StatusEnum.FAILED });
        await alert.accept();
        await driver.sleep(5000)
        await driver.navigate().refresh();
        await driver.quit();
        return new CommonResponseModel(false, 0, alertText)
      } else {
        await driver.sleep(10000)
        await driver.wait(until.elementLocated(By.xpath('//*[@id="orno"]')), 10000);
        const coNoElement = await driver.findElement(By.xpath('//*[@id="orno"]'));
        const coNo = await coNoElement.getAttribute('value');
        const currentDate = new Date();
        const day = currentDate.getDate().toString().padStart(2, '0');
        const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(currentDate);
        const year = currentDate.getFullYear().toString().slice(-2);
        const currentDateFormatted = `${day}-${month}-${year}`;
        if (coNo) {
          const update = await this.gantColineRepo.update(
            { poNumber: po.po_number, style: po.style },
            { coDate: currentDateFormatted, coNumber: coNo, status: 'Success', errorMsg: '-' }
          );
          await driver.sleep(3000)
          await this.updateCOLineStatus({ poNumber: po.po_number, style: po.style, status: StatusEnum.SUCCESS })
          return new CommonResponseModel(true, 1, "COline created successfully");
        } else {
          const update = await this.gantColineRepo.update({ poNumber: po.po_number, style: po.style }, { status: 'Failed', isActive: false, errorMsg: 'CO Number Not Found' });
          await driver.sleep(3000)
          await this.updateCOLineStatus({ poNumber: po.po_number, style: po.style, status: StatusEnum.FAILED })
          await driver.sleep(3000)
        }
      }
      return new CommonResponseModel(true, 1, `COline created successfully`)
    }
    catch (err) {
      console.log(err, 'error');
      if (err.message.includes("Error") || err.name.includes("Error") || err.message.includes("NoSuchElementError") || err.name.includes("NoSuchElementError") || err.message.includes("NoSuchWindowError") || err.name.includes("NoSuchWindowError")) {
        const update = await this.gantColineRepo.update({ poNumber: po.po_number, style: po.style }, { status: 'Open', errorMsg: "-" });
        await driver.sleep(3000)
        return new CommonResponseModel(false, 0, "CRM Error")
      }
      else if (err.message.includes("StaleElementReferenceError") || err.name.includes("StaleElementReferenceError")) {
        const update = await this.gantColineRepo.update({ poNumber: po.po_number, style: po.style }, { status: 'Open', errorMsg: "-" });
        await driver.sleep(3000)
        return new CommonResponseModel(false, 0, "CRM Error")
      }
      else {
        const update = await this.gantColineRepo.update({ poNumber: po.po_number, style: po.style }, { status: 'Failed', errorMsg: err.message, isActive: false });
        await driver.sleep(3000)
        return new CommonResponseModel(false, 0, err.message)
      }
    }
    finally {
      driver.quit()
    }
  }

  async isAlertPresent(driver) {
    try {
      await driver.switchTo().alert();
      return true;
    } catch (e) {
      return false;
    }
  }


}


